import { Outlet, useLocation, useNavigate, useNavigation } from "react-router-dom";
import PageTitle from "../../components/PageTitle";

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

export default function AdminSessionsHomePage() {
  // Work out which tab is currently active from the route.
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = [
    { name: "SDK Sessions", href: "/admin/sessions/sdk", current: false },
    {
      name: "Live App Sessions",
      href: "/admin/sessions/liveapp",
      current: false,
    },
  ];

  const activeTabIndex = tabs.findIndex((tab) =>
    location.pathname.startsWith(tab.href)
  );

  const handleTabChange = (index: number) => {
    if (index >= 0 && index < tabs.length) {
      const selectedTab = tabs[index];
      navigate(selectedTab.href);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <div>
        {/* Desktop Tabs */}
        <div className="block">
          <div className="border-b border-gray-200">
            <nav aria-label="Tabs" className="-mb-px flex">
              {tabs.map((tab, index) => (
                <a
                  key={tab.name}
                  href={tab.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleTabChange(index);
                  }}
                  aria-current={index === activeTabIndex ? "page" : undefined}
                  className={classNames(
                    index === activeTabIndex
                      ? "border-white text-gray-100"
                      : "border-transparent text-gray-300 hover:border-gray-300 hover:text-white",
                    "w-1/2 border-b-2 px-1 py-4 text-center text-sm font-medium"
                  )}
                >
                  {tab.name}
                </a>
              ))}
            </nav>
          </div>
        </div>
      </div>
      <Outlet />
    </div>
    
  );
}
